type GTagEvent = {
	action: string;
	value?: number;
};

export const GA_TRACKING_ID = "G-WQRZCZKWPX";

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageView = (url: URL): void => {
	window.gtag("config", GA_TRACKING_ID, {
		page_path: url,
	});
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, value }: GTagEvent): void => {
	window.gtag("event", action, value ? { value } : undefined);
};

type ConversionEventType = "PURCHASE" | "INITIATE_CHECKOUT";
interface ConversionEvent {
	email: string;
	value: number;
	transactionId: string;
	conversionType: ConversionEventType;
}

const conversionEventIDs: Record<ConversionEventType, string> = {
	PURCHASE: "m4PLCK2Sr4wZELHBpdAD",
	INITIATE_CHECKOUT: "fGgQCLD4uowZELHBpdAD",
};

export const conversionEvent = ({
	email,
	value,
	transactionId,
	conversionType,
}: ConversionEvent): void => {
	window.gtag("event", "conversion", {
		email,
		send_to: `AW-973693105/${conversionEventIDs[conversionType]}`,
		value,
		currency: "USD",
		transaction_id: transactionId,
	});
};
